import React from 'react';
import { AddressType } from '../CommonTypes';
import Selectable from '../Selectable';
import Address from './Address';
import './SelectableAddress.scss';

type SelectableAddressProps = {
    id: string;
    address: AddressType;
    selected: boolean;
    onClicked: (selected: boolean) => void;
    onEditSelectedAddress: () => void;
    style?: React.CSSProperties;
    editable?: boolean;
};

const SelectableAddress = ({
    id,
    address,
    selected,
    onClicked,
    onEditSelectedAddress,
    style,
    editable
}: SelectableAddressProps): JSX.Element => {
    return (
        <div className='selectableAddress--wrapper'>
            <Selectable
                id={`select${id}`}
                onClicked={(selected) => {
                    onClicked(selected);
                }}
                selected={selected}
                style={style}>
                <Address
                    id={id}
                    address={address}
                    onEditAddressClick={onEditSelectedAddress}
                    showEditButton={editable}
                />
            </Selectable>
        </div>
    );
};

export default SelectableAddress;
